import { styled } from '@mui/material/styles'
import { Box, Typography } from '@mui/material'
import { MuiButton } from '../../../../../components'
import { addZero } from '../../../../../util'

export const OuterWrapper = styled(Box)( props => `
  padding: 4px;
  display:flex;
`)

export const Wrapper = styled(Box)( props => `
  position: relative;
  background: #e0e0dd;
  border:1px #e0e0dd solid;
  padding: 23px;
  width: 100%;
  border-radius: 4px;
  display:flex;
  justify-content: center;
  align-items: center;

  &:before {
    content: '${addZero((props?.index || 0) + 1)}';
    position: absolute;
    top: 0;
    left: 0;
    color: #fff;
    font-size: 11px;
    font-weight: 400;
    width: 24px;
    height: 24px;
    background: #ADADAC;
    border-radius: 4px 0 4px 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }


  .selectWrap .MuiSelect-select {
    padding-right: 0 !important;
  }

  & .deleteButton {display:none; position:absolute; bottom:2px; right:2px;}

  &:hover { background: #fff;}
  &:hover .deleteButton {display:block;}
`)

export const InnerWrapper = styled(Box)( props => `
  max-width: 200px;
  width: 100%;
  display: flex;
  gap:10px;
  & > div {width:100%;}
  & .selectWrap {background: transparent !important; border: 0 !important;}
`)

export const Title = styled(Box)( props => `
  font-size: 10px;
  // font-wight: 600;
  position: absolute;
  left: 30px;
  top: 3px;
  color: #095BBD;
  
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: calc(100% - 40px);
`)

export const DragButton = styled(Box)( props => `
  position: absolute;
  left: 0;
  bottom: -5px;
  z-index: 1;
  cursor: grab;
`)

